exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".newTaille[data-v-32dc31e0]{font-size:1.1em;color:#000}.name-size[data-v-32dc31e0]{font-size:1.3em;color:#000}.couleur-orange[data-v-32dc31e0]{color:#ff9800;font-size:1.2em}.white-couleur[data-v-32dc31e0]{color:#fff}.v-data-table-header[data-v-32dc31e0]{background-color:#78b943;color:#fff}.theme--light.v-datatable thead th.column.sortable.active[data-v-32dc31e0],.theme--light.v-table thead th[data-v-32dc31e0]{color:#fff}.a-sans-style a[data-v-32dc31e0]{text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-32dc31e0","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/events/show.vue
// module id = KOn7
// module chunks = 1